import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CardFooterDirective } from './card-footer.directive';

@Component({
  selector: 'pxw-card-footer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content />',
  standalone: true,
  host: {
    class: 'pxw-card-footer',
  },
  hostDirectives: [CardFooterDirective],
})
export class CardFooterComponent {}
